// Copyright 2026. WebPros International GmbH. All rights reserved.

export const TABLE_ACTIONS = {
    SHOW_LOG_DATA: 'show-log-data',
};